'use client';
// Remove 'use client' from barrel exports to prevent forcing all imports into client bundle
// Add new components to the appropriate file based on their interactivity

// Re-export categorized components
export * from './blocks-components-static';
export * from './blocks-components-icons';
export * from './blocks-components-interactive';
